import { Link, useNavigate } from 'react-router-dom'
import { Alert, Button, Card, Checkbox, Form, Input, Typography, message } from 'antd'
import { signupMessenger } from '../services/api'
import { useAuth } from '../hooks/useAuth'
import { productName } from '../branding'

const { Title, Paragraph } = Typography

export default function SignupPage() {
  const navigate = useNavigate()
  const { setSessionToken } = useAuth()
  const [form] = Form.useForm()
  const name = productName()

  const onFinish = async (values: {
    email: string
    password: string
    firstName: string
    lastName: string
    businessName: string
    phone?: string
    agreeToTerms: boolean
  }) => {
    try {
      const result = await signupMessenger(values)
      setSessionToken(result.token)
      message.success('Account created — complete checkout to activate')
      if (result.checkoutUrl) {
        window.location.href = result.checkoutUrl
        return
      }
      navigate('/dashboard')
    } catch (e: unknown) {
      const err = e as { response?: { data?: { message?: string } }; message?: string }
      message.error(err.response?.data?.message || err.message || 'Signup failed')
    }
  }

  return (
    <div style={{ maxWidth: 520, margin: '48px auto', padding: '0 16px' }}>
      <Card
        className="messenger-card"
        style={{
          background: '#ffffff',
          border: '1px solid #cbd5e1',
          boxShadow: '0 8px 30px rgba(15, 23, 42, 0.08)',
        }}
      >
        <Title level={2} style={{ color: '#0f172a', marginTop: 0 }}>
          Start {name}
        </Title>
        <Paragraph style={{ color: '#475569' }}>$20/month. Cancel anytime after checkout.</Paragraph>
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16, background: '#eff6ff', borderColor: '#bfdbfe' }}
          message="After signup you’ll complete Stripe checkout, then connect Facebook in one click."
        />
        <Form layout="vertical" form={form} onFinish={onFinish} requiredMark={false}>
          <Form.Item name="businessName" label="Business name" rules={[{ required: true }]}>
            <Input size="large" placeholder="Acme Plumbing" />
          </Form.Item>
          <Form.Item name="firstName" label="First name" rules={[{ required: true }]}>
            <Input size="large" />
          </Form.Item>
          <Form.Item name="lastName" label="Last name" rules={[{ required: true }]}>
            <Input size="large" />
          </Form.Item>
          <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
            <Input size="large" type="email" autoComplete="email" />
          </Form.Item>
          <Form.Item name="phone" label="Phone (optional)">
            <Input size="large" />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true, min: 8 }]}>
            <Input.Password size="large" autoComplete="new-password" />
          </Form.Item>
          <Form.Item
            name="agreeToTerms"
            valuePropName="checked"
            rules={[
              {
                validator: (_, v) =>
                  v ? Promise.resolve() : Promise.reject(new Error('You must agree to continue')),
              },
            ]}
          >
            <Checkbox>I agree to the terms of service</Checkbox>
          </Form.Item>
          <Button type="primary" htmlType="submit" size="large" block>
            Create account & checkout — $20/mo
          </Button>
        </Form>
        <Paragraph style={{ marginTop: 16, color: '#475569', marginBottom: 0 }}>
          Already have an account? <Link to="/login">Log in</Link>
        </Paragraph>
      </Card>
    </div>
  )
}
